import styled from 'styled-components';

export const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #fff;
  margin-top: 8px;
  height: 100%;
`;

export const Header = styled.div`
  height: 40px;
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 5px 0 15px;
  button {
    height: 100%;
    width: 40px;
    background: url('/images/ic-analysis-write.png') no-repeat center center;
    background-size: 15px;
  }
`;

export const List = styled.ul``;

export const ListItem = styled.li`
  border-top: 1px solid #f2f2f2;
  > a {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 80px;
    padding: 0 15px;
    :visited .subject {
      color: #999;
    }
  }
`;

export const Summary = styled.div`
  display: flex;
  flex-direction: column;
  max-width: calc(100% - ${(props) => (props.isThumb ? '70px' : '0px')});
  > p {
    line-height: 19px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 3px;
  }
  > span {
    font-size: 12px;
    color: #222;
  }
  > div {
    display: flex;
    span {
      font-size: 12px;
      color: #999;
      margin-right: 8px;
      display: flex;
      align-items: center;
      &.like {
        :before {
          content: '';
          width: 9px;
          height: 9px;
          display: inline-block;
          background: url('/images/ic-like.svg') no-repeat center center;
          background-size: 9px;
          margin-right: 5px;
        }
      }
      &.hit {
        :before {
          content: '';
          width: 14px;
          height: 14px;
          display: inline-block;
          background: url('/images/ic-hit.svg') no-repeat center center;
          background-size: 14px;
          margin-right: 5px;
        }
      }
    }
  }
`;

export const Thumb = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 6px;
  background-color: #f5f6f8;
  overflow: hidden;
  > img {
    display: block;
    width: 56px;
    height: 56px;
    border-radius: 3px;
  }
`;

export const NoneContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #f1f2f4;
  height: 100%;
  > p {
    font-size: 18px;
  }
`;
